var map = {
	"./colabs-portfolio_0.jpg": 69,
	"./colabs-portfolio_02.jpg": 70,
	"./colabs-portfolio_03.jpg": 71,
	"./colabs-portfolio_04.jpg": 16,
	"./colabs-portfolio_05.jpg": 72,
	"./colabs-portfolio_06.jpg": 73,
	"./colabs-portfolio_07.jpg": 74,
	"./colabs-portfolio_08.jpg": 75,
	"./colabs-portfolio_09.jpg": 76,
	"./colabs-portfolio_10.jpg": 77
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68;